<script setup lang="ts">

interface Props {
    color?: 'main' | 'secondary' | 'success' | 'info' | 'danger' | 'warning' | 'gray' | 'light' | 'white'
    type?: 'normal' | 'outline'
    size?: 'small' | 'normal' | 'large'
    design?: 'rounded' | 'pill' | 'rounded-s' | 'rounded-e' | 'rounded-none'
    shadow?: boolean,
    border?: boolean,
    disabled?: boolean
}

const variantClass = {
    main: {
        normal: 'bg-orange-500 border-orange-600 shadow-orange-600 text-white',
        outline: 'bg-white border-orange-500 shadow-orange-500 text-orange-500'
    },
    secondary: {
        normal: 'bg-blue-500 border-blue-600 shadow-blue-600 text-white',
        outline: 'bg-white border-blue-500 shadow-blue-500 text-blue-500'
    },
    success: {
        normal: 'bg-lime-500 border-lime-600 shadow-lime-600 text-white',
        outline: 'bg-white border-lime-500 shadow-lime-500 text-lime-500'
    },
    info: {
        normal: 'bg-sky-500 border-sky-600 shadow-sky-600 text-white',
        outline: 'bg-white border-sky-500 shadow-sky-500 text-sky-500'
    },
    danger: {
        normal: 'bg-red-500 border-red-600 shadow-red-600 text-white',
        outline: 'bg-white border-red-500 shadow-red-500 text-red-500'
    },
    warning: {
        normal: 'bg-yellow-500 border-yellow-600 shadow-yellow-600 text-white',
        outline: 'bg-white border-yellow-500 shadow-yellow-500 text-yellow-500'
    },
    gray: {
        normal: 'bg-gray-300 border-gray-400 shadow-gray-400 text-white',
        outline: 'bg-white border-gray-300 shadow-gray-300 text-gray-300 '
    },
    light: {
        normal: 'bg-gray-200 border-gray-300 shadow-gray-300 text-white',
        outline: 'bg-white border-gray-200 shadow-gray-200 text-gray-200 '
    },
    white: {
        normal: 'bg-white border-gray-50/50 shadow-gray-50/50 text-gray-50/60 ',
        outline: 'border-gray-200 text-gray-400 '
    }
}

const sizeClass = {
    small: 'px-3 py-1 text-sm',
    normal: 'px-5 py-2 text-base',
    large: 'px-7 py-3 text-xl'
}

const designClass = {
    rounded: 'rounded-md',
    pill: 'rounded-full',
    'rounded-s': 'rounded-s-md border-e-0',
    'rounded-e': 'rounded-e-md border-s-0',
    'rounded-none': 'rounded-none'
}

const {
    color = 'main',
    type = 'normal',
    size = 'normal',
    design = 'rounded',
    shadow = true,
    border = true,
    disabled = false
} = defineProps<Props>()
</script>

<template>
    <button tabindex="-1" class="flex justify-center items-center gap-2 font-bold transition-all duration-200 hover:brightness-110 focus:brightness-110" :class="[
        variantClass[color][type],
        sizeClass[size],
        designClass[design],
        {
            'cursor-not-allowed': disabled,
            'shadow-[0_6px_0]': shadow && size === 'large',
            'shadow-[0_4px_0]': shadow && size === 'normal',
            'shadow-[0_2px_0]': shadow && size === 'small',
            'border-2': border
        }
    ]" :disabled="disabled">
        <slot></slot>
    </button>
</template>